<template>
    <div class="row">
        <div class="form-group col-md-6">
            <label :for="'hall' + _uid" class="required">{{ $t('hall.hall') }}</label>
            <input type="text" class="form-control"
                   :id="'hall' + _uid"
                   v-model="hall.name"
                   v-validate="'required'"
                   :data-vv-as="$t('hall.hall')"
                   :name="'hall' + _uid" />
            <span class="text-danger" v-if="errors.has('hall' + _uid)">{{ errors.first('hall' + _uid) }}</span>
        </div>
        <div class="form-group col-md-6">
            <label :for="'capacity' + _uid" class="required">{{ $t('hall.capacity') }}</label>
            <input type="number" class="form-control"
                   :id="'capacity' + _uid"
                   v-model="hall.capacity"
                   v-validate="'required'"
                   :data-vv-as="$t('hall.capacity')"
                   :name="'capacity' + _uid" />
            <span class="text-danger" v-if="errors.has('capacity' + _uid)">{{ errors.first('capacity' + _uid) }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: {
            hall: Object
        }
    }
</script>

<style scoped></style>
